import * as React from 'react';
/**
 *
 * Original name: revert file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1049
 *
 */
export const RevertFileLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M7 5.5h7V8h2.5v3a5.363 5.363 0 0 1 1.5.415V7.621a2.265 2.265 0 0 0-.659-1.591l-1.372-1.371A2.265 2.265 0 0 0 14.38 4H5.5v16h8.994v-1.5H7v-13Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M18.485 13.505a3.655 3.655 0 0 0-2.77-1A4.228 4.228 0 0 0 13 13.723V12h-1.5v4.5H16V15h-2.165a2.882 2.882 0 0 1 1.925-1 2.19 2.19 0 0 1 1.665.564 2.301 2.301 0 0 1 .563 1.686 2.299 2.299 0 0 1-.564 1.687 2.16 2.16 0 0 1-1.43.546v1.507a3.677 3.677 0 0 0 2.491-.99 3.777 3.777 0 0 0 1-2.75 3.775 3.775 0 0 0-1-2.745Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
